WiseMetering.Views.NewElectricityMapsIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/electricity_maps/new',
    ui: {
        sites: '#site_id',
        indicators: '#integration_indicator_id'
    },
    events: {
        'change #integration_emission_factor_type': 'updateDescription',
        'change @ui.sites': 'onSiteChange'
    },
    title: () => i18next.t('modal.title.integrations.new'),

    afterSave: function() {
        WiseMetering.indicators.fetch();
    },

    getFormData: function() {
        const data = this.formSerializer();
        data.partner_id = this.options.license.get('partner_id');
        return data;
    },

    onSiteChange: function() {
        const selectedSiteId = this.ui.sites.val();

        if (!selectedSiteId) {
            this.ui.indicators.empty();
            return;
        }

        const
            usedIndicatorsIds = this.model.license().indicators().pluck('id'),
            availableIndicators = WiseMetering.indicators.models.filter(function(indicator) {
                const
                    activeEnergy = indicator.get('kind_slug') === 'active_energy',
                    inSite = indicator.get('site_id') === selectedSiteId,
                    notUsed = !usedIndicatorsIds.includes(indicator.id);

                return activeEnergy && inSite && notUsed;
            }),
            indicators = WiseMetering.utils.optionsFromModels(availableIndicators, 'name', null, availableIndicators.length !== 1);

        this.ui.indicators.html(indicators);
    },

    onShow: function() {
        this.updateDescription();

        const
            sites = WiseMetering.zones.activeSites().filter(site => site.get('timezone') === 'Europe/Lisbon');

        this.ui.sites.html(WiseMetering.utils.optionsFromModels(sites, 'name', null, sites.length !== 1));
        this.onSiteChange();
    },

    updateDescription: function() {
        const
            selectedType = this.$('#integration_emission_factor_type').val(),
            description = i18next.t(`integration_partners.partners.electricity_maps.${selectedType}_description`),
            title = i18next.t(`integration_partners.partners.electricity_maps.${selectedType}_title`),
            warningContainer = this.$('#emission-factor-container'),
            warningElement = this.$('#emission-factor-warning');

        if (selectedType === 'direct' && warningElement.length === 0) {
            const warningText = i18next.t(`integration_partners.partners.electricity_maps.warning`);

            warningContainer.prepend(`<p id="emission-factor-warning" class="modal-description-warning">${warningText}</p>`);
        } else {
            warningElement.remove();
        }

        this.$('#emission-factor-title').text(title);
        this.$('#emission-factor-description').text(description);
    }
});
